import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDeals } from "../../CustomHooks/Queries";
import {
  BATTLECARD_FLOW_NAV_STATE,
  formatCurrency,
  getLegacyCheckErrorFromDealsResponse,
  getLegacyCheckRouteFromDealsResponse,
  isLegacyCheckNotProcessedFromDealsResponse,
} from "../../Utils/helpers";
import { WarningIcon } from "./check-warning";
import LegacyCheckPageLayout from "./legacy-check-page-layout";
import "./battle-cards.scss";

export default function CheckNotProcessed() {
  const navigate = useNavigate();
  const { data: dealsData, isLoading: isLoadingDeals } = useDeals();

  const isNotProcessed = isLegacyCheckNotProcessedFromDealsResponse(dealsData);

  const { title, description, amount } = useMemo(
    () => getLegacyCheckErrorFromDealsResponse(dealsData),
    [dealsData]
  );

  useEffect(() => {
    if (isLoadingDeals || isNotProcessed) return;

    navigate(getLegacyCheckRouteFromDealsResponse(dealsData), {
      replace: true,
      state: BATTLECARD_FLOW_NAV_STATE,
    });
  }, [dealsData, isLoadingDeals, isNotProcessed, navigate]);

  if (!isNotProcessed) {
    return <div className="battle-cards-page" />;
  }

  return (
    <LegacyCheckPageLayout>
      <div className="battle-cards-page bc-check-not-processed-page">
        <div className="bc-check-not-processed-card">
          <WarningIcon />
          <h2 className="bc-check-not-processed-title">{title}</h2>
          <p className="bc-check-not-processed-body">{description}</p>
          {amount != null && (
            <div className="bc-check-not-processed-amount">
              <span className="bc-check-not-processed-amount-label">Cash Back</span>
              <span className="bc-check-not-processed-amount-value">{formatCurrency(amount)}</span>
            </div>
          )}
        </div>
      </div>
    </LegacyCheckPageLayout>
  );
}
